import { render, staticRenderFns } from "./TopesReasons.vue?vue&type=template&id=b8978062"
import script from "./TopesReasons.vue?vue&type=script&lang=js"
export * from "./TopesReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports